import { render, staticRenderFns } from "./ContextNotifications.vue?vue&type=template&id=6c8f0fde&scoped=true&"
import script from "./ContextNotifications.vue?vue&type=script&lang=ts&"
export * from "./ContextNotifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f0fde",
  null
  
)

export default component.exports